import React, { useEffect,useState } from 'react';

import { useParams, useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { resolveTo } from '~/commons/helpers';
import ModalAlert from '~/commons/components/ModalAlert.jsx';

import FieldsQuestions from '~/app/components/forms/FieldsQuestions.jsx';

const PageCompetitionPreview = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();
  const [locked, setLocked] = useState(null);
  const history = useHistory();

  useEffect(() => {
    req({
      url: `api/quiz/competitions/${_id}`,
    });
  }, []);
  useEffect(() => {
    fetch('api/quiz/competitions/'+_id+'/lock')
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        // history.push(resolveTo('', row._id));
      } else {
        setLocked(data.comp.locked);
      }
    }).catch((err) => {
      console.error('err', err);
    })
    return () => {
      fetch('api/quiz/competitions/'+_id+'/unlock');
    };
  }, []);

  return (
    <>
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header
            breadcrumb={[
              { to: '../../', children: 'Competitions' },
              { to: '../', children: `${doc.title} - ${doc.refCode}` },
            ]}
          >Preview</Header>
          <Tabs unmountOnExit>
            {doc.questionSets.map((qs) => (
              <Tab
                key={qs._id}
                eventKey={qs._id}
                title={qs.refCode}
              >
                <Formik
                  initialValues={{
                    answers: qs.questions.map((q) => ({
                      question: q._id,
                      format: q.format, // just for validation only
                      answered: undefined,
                      answeredSeq: (
                        ['ordering', 'matching'].includes(q.format)
                          ? q.choices.map(() => undefined)
                          : []
                      ),                      
                    })),
                  }}
                >
                  <Form>
                    <FieldsQuestions questions={qs.questions.map(q=>{
                      return {
                        ...q,
                        choices: q.choices.map((c,ii)=>({c, ii, r: Math.random()})).sort((a,b)=>a.r-b.r),
                      }
                    })} />
                  </Form>
                </Formik>
              </Tab>
            ))}
          </Tabs>
        </>
      )}
    </PageHttp>
    <ModalAlert
      show={locked!=null}
      onHide={() => {
        setLocked(null);
        history.push(resolveTo(`../../`));
      }}
    >
      {locked ? locked.by.name.full.en : ''} 正在使用中，請稍後再試。
    </ModalAlert>
    </>
  );
};

export default PageCompetitionPreview;
